<template>
  <div id="smartEnergyChart">
    <div id="chartBox" ref="chartBox"></div>
  </div>
</template>
<script>
import echarts from "echarts/lib/echarts";
import { energyDataType, dateType } from "@/utils/typeParam";
// 引入折线图
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
import "echarts/lib/component/legend";
import "echarts/lib/component/title";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/dataZoom";

export default {
  name: "smartEnergyChart",
  data() {
    return {
      seriesDataArr: [],
      legendArr: [],
      yAxisArr: []
    };
  },
  props: { 
    dataSource: Object
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.chartBox);
    this.initData();
  },
  methods: {
    //整理数据
    finishingData() {
      var seriesList = [];
      var legendList = [];
      var yAxisList = [];
      var yAxis0;
      var yAxis1;
      this.dataSource.yAxisData.forEach(value => {
        var energyColor = "";
        var energyName = "";
        var energyData;
        var energyUnit = "";
        if (value.energyType == energyDataType.gas) {
          energyColor = "#F38F3F";
          energyName = "耗气量";
          energyUnit = "m³";
          energyData = this.getYaxisData(value.dataArr);
        }
        if (value.energyType == energyDataType.waterYield) {
          energyColor = "#4A9AF4";
          energyName = "耗水量";
          energyUnit = "L";
          energyData = this.getYaxisData(value.dataArr);
        }
        if (value.energyType == energyDataType.heaterConsumptionGasRate) {
          energyColor = "#F38F3F";
          energyName = "每升水耗气量";
          energyUnit = "m³";
          energyData = value.dataArr;
        }
        seriesList.push({
          type: "line",
          name: energyName,
          smooth: true,
          yAxisIndex: value.yAxisIndex,
          itemStyle: {
            color: energyColor
          },
          lineStyle: {
            color: energyColor
          },
          data: energyData
        });
        legendList.push(energyName);

        var yAxis = {
          type: "value",
          name: energyName,
          splitLine: {
            show: true //显示分割区域
          },
          axisLine: {
            lineStyle: {
              color: "#999"
            }
          },
          axisTick: {
            show: true //显示刻度
          },
          axisLabel: {
            interval: 0, //显示所有标签
            formatter: "{value}" + " " + energyUnit
          }
        };
        if (value.yAxisIndex == 0) {
          yAxis0 = yAxis;
        }
        if (value.yAxisIndex == 1) {
          yAxis1 = yAxis;
        }
      });
      yAxisList.push(yAxis0);
      if (yAxis1 != undefined) {
        yAxisList.push(yAxis1);
      }
      this.$set(this, "seriesDataArr", seriesList);
      this.$set(this, "legendArr", legendList);
      this.$set(this, "yAxisArr", yAxisList);
    },
    //处理纵坐标数据,整体除100
    getYaxisData(yAxisData) {
      var data = [];
      yAxisData.forEach(yAxisDataItem => {
        data.push(yAxisDataItem / 100);
      });
      return data;
    },
    initData() {
      //整理数据
      this.finishingData();
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            },
            textStyle: {
              color: "#999"
            }
          }
        },
        legend: {
          data: this.legendArr
        },
        grid: {
          show: true,
          borderWidth: 0,
          top: 40,
          bottom: 20,
          textStyle: {
            color: "#999"
          }
        },
        calculable: true,
        xAxis: {
          type: "category",
          boundaryGap: false,
          splitLine: {
            show: false
          },
          axisTick: {
            show: true
          },
          axisLabel: {
            interval: 0 //设置成0，强制显示所有刻度
          },
          data: this.dataSource.xAxisData
        },
        yAxis: this.yAxisArr,
        dataZoom: [
          {
            type: "inside",
            show: false,
            xAxisIndex: [0],
            height: 1,
            start: 1,
            end: 100
          }
        ],
        series: this.seriesDataArr
      };
      this.myChart.setOption(option);
    }
  }
};
</script>
<style scoped>
#smartEnergyChart {
  width: 100%;
  height: 100%;
}
#chartBox {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/subComponents/smartEnergyChartComponent.vue